import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { useLanguage } from "@/context/LanguageContext";
import { footerLabels } from "@/i18n";
import { useNativeExpandableSheetProps } from "@/lib/native/useNativeExpandableSheetProps";
import { cn } from "@/lib/utils";

interface AboutDialogProps {
    open: boolean;
    onOpenChange: (open: boolean) => void;
}

const AboutDialog: React.FC<AboutDialogProps> = ({ open, onOpenChange }) => {
    const { language } = useLanguage();
    const labels = footerLabels(language);
    const nativeSheetProps = useNativeExpandableSheetProps(open, {
        nativeClass: "native-legal-sheet native-sheet-expandable",
        className: "rounded-lg max-w-sm",
    });
    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent
                {...nativeSheetProps}
                className={cn(nativeSheetProps.className)}
            >
                <DialogHeader>
                    <DialogTitle>{labels.aboutDialog.title}</DialogTitle>
                </DialogHeader>
                <div className="space-y-2">
                    <p>{labels.aboutDialog.paragraph1}</p>
                    <p>{labels.aboutDialog.paragraph2}</p>
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default AboutDialog;
